import { router } from '@/app/router';
import { RouterProvider } from '@tanstack/react-router';
import { Provider as ReduxProvider } from 'react-redux';
import { persistStore } from 'redux-persist';
import { store } from '@/app/store';

import { PersistGate } from 'redux-persist/integration/react';

import { Toaster } from '@/components/ui/toaster';

import FullPageLoader from './components/full-page-loader';
import { ThemeProvider } from './components/theme-provider';
import { Theme as RadixTheme } from '@radix-ui/themes';
import { AuthProvider, useAuth } from './contexts/auth-context';
import { TenantProvider } from './contexts/tenant-context';
import { AIChatWidget } from '@/components/ai/ai-chat-widget';

const persistor = persistStore(store);

function InternalApp() {
  const auth = useAuth();

  if (auth.isLoading) {
    return <FullPageLoader />;
  }

  return (
    <>
      <Toaster />
      <RouterProvider router={router} context={{ auth }} />
      {/* <AIChatWidget /> */}
    </>
  );
}

function App() {
  return (
    <ReduxProvider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <AuthProvider>
          <TenantProvider>
            <ThemeProvider defaultTheme="dark" storageKey="vite-ui-theme">
              <RadixTheme accentColor="jade">
                <InternalApp />
              </RadixTheme>
            </ThemeProvider>
          </TenantProvider>
        </AuthProvider>
      </PersistGate>
    </ReduxProvider>
  );
}

export default App;
